'use strict';

var ES6Promise = require("es6-promise").Promise;

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jszip/lib/external.js
// module id = vVrn
// module chunks = 0